import { render } from "./PhoneConfirm.vue?vue&type=template&id=db2b1578&scoped=true"
import script from "./PhoneConfirm.vue?vue&type=script&lang=js"
export * from "./PhoneConfirm.vue?vue&type=script&lang=js"

import "./PhoneConfirm.vue?vue&type=style&index=0&id=db2b1578&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2b1578"]])

export default __exports__